import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ReCAPTCHA from 'react-google-recaptcha';
import { makeStyles } from '@material-ui/core/styles';
import { shadows } from '@material-ui/system';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import {
    loadLoginData,
    saveLoginData,
    updateLoginData,
    updateLoginDataAction,
    loginAction,
    logout,
    isAuthenticatedAction, clientTypeChange
} from "../../redux/modules/login";
import {bindActionCreators} from "redux";
import { connect } from 'react-redux';
import Image from "material-ui-image";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import { Redirect, Route } from 'react-router-dom';
import  axios  from 'axios';
import { AES, enc } from 'crypto-js';
import jwt_decode from "jwt-decode";
import MainView from "./MainView";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FormControl from "@material-ui/core/FormControl";
import {loadSingleUserAndCompanyData} from "../../redux/modules/user";
import {IconButton, InputAdornment} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import * as MainConstants from "../../utils/MainConstants";
//import { Redirect } from 'react-router-dom';





const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder),
    multilineColor:{
        color:'red'
    }
    
});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
    multilineColor:{
        color:'black',
        backgroundColor:'#f5f7e8'
    },
    button: {
        marginTop: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit*3,
        //backgroundColor: "#09827a",
        backgroundColor: "#0fa69e",
        border:'2px solid green',
        borderColor:'white',
        width:'40%',
        color: "black",
        height:40,
        fontSize:26,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
    },
    buttonsignup2: {
        marginTop: theme.spacing.unit * 11,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        width:'95%',
        border:'2px solid green',
        borderColor:'black',
        color: "black",
        height:40,
        fontSize:16,
        fontWeight:800,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    },
    buttonsignup: {
        marginTop: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        width:'95%',
        color: "black",
        border:'2px solid green',
        borderColor:'black',
        height:40,
        fontSize:16,
        fontWeight:800,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    },
    /*buttonnu: {
        marginTop: theme.spacing.unit * 1,
        marginLeft: theme.spacing.unit,
        backgroundColor: "#09827a",
        width:'95%',
        color: "black",
        height:40,
        fontSize:16,
        fontWeight:800
        
    }*/
    
    buttonnu: {
        marginTop: theme.spacing.unit * 2,
        marginLeft: theme.spacing.unit * 3,
        //backgroundColor: "#0fa69e",
        backgroundColor: "#09827a",
        border:'2px solid green',
        borderColor:'white',
        width:'50%',
        color: "black",
        height:40,
        fontSize:16,
        fontWeight:400,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
        
    },
    buttonfp: {
        marginTop: theme.spacing.unit * 2,
        marginLeft: theme.spacing.unit * 3,
        //backgroundColor: "#0fa69e",
        backgroundColor: "#09827a",
        border:'2px solid green',
        borderColor:'white',
        width:'50%',
        color: "black",
        height:40,
        fontSize:`14`,
        fontWeight:400,
        '&:hover': {
            backgroundColor: 'white', // Background color on hover
            color: 'black', // Optional: Change text color on hover
        },
    },
    formControlLogin: {
        //margin: theme.spacing.unit,
        width: '60%',
        
    },
    backgroundImage: {
        flexGrow: 1,
        padding: theme.spacing(3),
        textAlign: 'left',
        //backgroundImage: 'url(/static/images/img3692b.png)',
        backgroundImage: 'url(/static/images/boston1.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        height: '400vh', // Default height for larger screens
        
        // Responsive styling
        [theme.breakpoints.down('lg')]: {
            height: '200vh',
        },
        [theme.breakpoints.down('md')]: {
            // Customize height for medium-sized screens if needed
            height: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            // Customize height for smaller screens if needed
            height: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            // Customize height for extra-small screens if needed
            height: '100%',
        },
    }
});

//const recaptchaRef = useRef(null);


class Login extends Component {
    
    state = {
        age: '',
        firstname: '',
        lastname:'',
        email:'',
        comment:'',
        userComment:{},
        usernameString: '',
        password: '',
        showPassword:false,
        slideAnimationDialog:false,
        errorDialog:false,
        passwordHolder:"Password",
        emailHolder:"Email",
        showPasswordDialog:false,
        newpasswordemail:"",
        showResponseOkDialog:false,
        showNewPasswordErrorDialog:false,
        clientType:"",
        captchaValue:"",
        captchaValueNewPass:"",
        
        
    };
    constructor(props) {
        super(props);
        this.errorMessage="";
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.onLoginToPlatewizPressed = this.onLoginToPlatewizPressed.bind(this);
        this.renderRedirectHome = this.renderRedirectHome.bind(this);
        this.encrypt = this.encrypt.bind(this);
        this.loginToPlatewizOnServer = this.loginToPlatewizOnServer.bind(this);
        this.getArrayOfLoginToPlatewiz = this.getArrayOfLoginToPlatewiz.bind(this);
        this.handleClickShowSavedCard = this.handleClickShowSavedCard.bind(this);
        this.handleClickShowSuccessClose = this.handleClickShowSuccessClose.bind(this);
        this.handleClickShowErrorCard = this.handleClickShowErrorCard.bind(this);
        this.handleClickShowErrorClose = this.handleClickShowErrorClose.bind(this);
        
        this.onForgotPasswordPressed = this.onForgotPasswordPressed.bind(this);
        this.handleForgotPasswordClose = this.handleForgotPasswordClose.bind(this);
        this.handleNewPasswordEmailChange = this.handleNewPasswordEmailChange.bind(this);
        this.onSendPasswordPressed = this.onSendPasswordPressed.bind(this);
        this.showResponseOkClose = this.showResponseOkClose.bind(this);
        
        this.handleNewPasswordErrorClose = this.handleNewPasswordErrorClose.bind(this);
        this.showNewPasswordError = this.showNewPasswordError.bind(this);
        this.handleResponseOkClose = this.handleResponseOkClose.bind(this);
        this.onSendPasswordCancel = this.onSendPasswordCancel.bind(this);
        this.onClientTypeChangeValue= this.onClientTypeChangeValue.bind(this);
        this.handleClickShowPassword= this.handleClickShowPassword.bind(this);
        this.handleCaptchaChange= this.handleCaptchaChange.bind(this);
        this.handleCaptchaChangeNewPass= this.handleCaptchaChangeNewPass.bind(this);
       
        this.recaptchaRef = React.createRef();
        this.recaptchaRefNewPass = React.createRef();
       
        
    }
    
    
    
    handleCaptchaChange = (value) => {
        this.setState({ captchaValue: value });
    };
    
    handleCaptchaChangeNewPass = (value) => {
        this.setState({ captchaValueNewPass: value });
    };
    encrypt(value) {
        console.log("Inside encrypt");
        var key = "$Gh0rm3hS8bz1B0st0n1979$$7iwt8lP37!@";
        let cipherData = AES.encrypt(value, key );
        //console.log("Encrypted Password is  "+cipherData.toString() );
        return  cipherData.toString();
    }
    
    componentDidMount(){
        let { loginAction } = this.props;
        //this.props.auth.login();
        //loginAction();
    }
    
    renderRedirectHome(){
        
        return <Redirect to='/towcompany' />
        //return <Route path='/'   />
        //return <MainView {...props} />
    }
    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleEmailChange(event) {
        //event.preventDefault();
        this.setState( { email: event.target.value });
    }
    
    handlePasswordChange(event) {
        //event.preventDefault();
        this.setState( { password: event.target.value });
    }
    
    handleSubmit() {
        
        
        /* let { saveAVehicle } = this.props;
				 
				 //var tempStream = this.state.selectedVehicle ;
				 var tempStream = {};
				 tempStream = this.setTheVehicleInformation(tempStream);
				 //tempStream.locationId= this.state.selectedLocation.id;
				 saveAVehicle(DEFAULT_VESPAAN_SERVER.url, tempStream);*/
     
    };
    
    // This is for reCaptchaValue
    
    onLoginToPlatewizPressed(event) {
        //let { loginToPlatewiz} = this.props;
        event.preventDefault();
        //console.log('Form submitted with reCAPTCHA:', this.state.captchaValue);
        if (this.state.captchaValue) {
            //console.log('Form submitted with reCAPTCHA:', this.state.captchaValue);
            let allLowerCaseUsername = this.state.email;
            allLowerCaseUsername = allLowerCaseUsername.toLowerCase();
            //loginToPlatewiz(MainConstants.DEFAULT_VESPAAN_SERVER.url, allLowerCaseUsername, this.state.passwordString);
            this.loginToPlatewizOnServer(DEFAULT_VESPAAN_SERVER.url, allLowerCaseUsername, this.state.password,this.state.captchaValue );
            // To reset reCAPTCHA manually
            this.recaptchaRef.current.reset();
        } else {
            // Handle case where reCAPTCHA is not solved
            console.log('Please complete the reCAPTCHA');
            alert('Please complete the reCAPTCHA first');
        }
    }
    
    
    /*onLoginToPlatewizPressed() {
         
            let allLowerCaseUsername = this.state.email;
            allLowerCaseUsername = allLowerCaseUsername.toLowerCase();
            //loginToPlatewiz(MainConstants.DEFAULT_VESPAAN_SERVER.url, allLowerCaseUsername, this.state.passwordString);
            this.loginToPlatewizOnServer(DEFAULT_VESPAAN_SERVER.url, allLowerCaseUsername, this.state.password);
            
    }*/
    
    loginToPlatewizOnServer( argURL, argUsername, argPassword, argReCaptchaToken){
        //const { navigate } = this.props.navigation;
        let { loadSingleUserAndCompanyData } = this.props;
        let { updateLoginDataAction, isAuthenticatedAction} = this.props;
        var self=this;
        
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(self.getArrayOfLoginToPlatewiz(argURL, argUsername, argPassword, argReCaptchaToken)).then(function(responses){
                // var token = 'eyJ0eXAiO.../// jwt token';
                //console.log(responses[0].data);
                
                var decoded = jwt_decode(responses[0].data.accessToken);
                //console.log(decoded);
                //console.log(decoded.exp * 1000);
                //console.log(new Date().getTime());
                //console.log((decoded.exp * 1000 - new Date().getTime())/(1000*60*60));
                if (decoded.exp * 1000 < new Date().getTime()) {
                    
                    console.log('Time Expired');
                }else{
                    console.log('Time is not Expired');
                }
                
                let expiresAt = (decoded.exp * 1000) + new Date().getTime();
                
                updateLoginDataAction(responses[0].data);
                isAuthenticatedAction(expiresAt)
                if(self.props.clientType === 'towCompany') {
                    loadSingleUserAndCompanyData(DEFAULT_VESPAAN_SERVER.url);
                }
                self.handleClickShowSavedCard();
                //self.renderRedirectHome();
                //navigate("Menu", {screen: "Menu"});
                
                //resolve(responses[0].data);
                
            }, function(err) {
                console.log("err");
                console.log(err);
                console.log("err.message");
                console.log(err.message);
                console.log("err.message.data");
                console.log(err.response.data);
                console.log("err.message.data.status");
                console.log(err.response.status);
                console.log(err.response.headers);
                console.log("Farshid some error occured on login to server " + err.message +  " the URL is " + argURL );
                self.errorMessage = "Login Failed ("+ err.response.status+")";//err.response.data.message;
                self.handleClickShowErrorCard();
                //self.setErrorDialog(true);
                //reject(err);
            });
        }
        
        
        
    }
    
    
    
    
    
    //getArrayOfLoginToPlatewiz(argURL, argUsername, argPassword){
    getArrayOfLoginToPlatewiz(argURL, argUsername, argPassword, argReCaptchaToken){
        
        //let baseUrl = argURL+"authenticate";
       let baseUrl = argURL+"webauthenticate"+"?recaptchatoken="+argReCaptchaToken;
        //console.log(" on posting a login the URL is " + baseUrl );
        
        var arrayOfGets = [];
        if(argURL != null) {
            
            let enctyptedPasswordd = this.encrypt(argPassword);
            //console.log("Encrypted Password is  "+enctyptedPasswordd );
            //test user = test2user, test2password
            /*arrayOfGets.push(axios.post(baseUrl, { "username": argUsername,
                "password": enctyptedPasswordd}));*/
            arrayOfGets.push(axios.post(baseUrl, { "username": argUsername,
                "password": enctyptedPasswordd}, ));
            
            
        }
        return arrayOfGets;
    }
    
    
    handleResponseOkClose() {
        this.setState({ showResponseOkDialog: false });
        this.setState({ showPasswordDialog: false });
        
    };
    
    showResponseOkClose() {
        this.setState({ showResponseOkDialog: true });
    };
    
    showNewPasswordError() {
        this.setState({ showNewPasswordErrorDialog: true });
    };
    handleNewPasswordErrorClose() {
        this.setState({ showNewPasswordErrorDialog: false });
    };
    onForgotPasswordPressed() {
        this.setState({ showPasswordDialog: true });
    };
    
    handleForgotPasswordClose() {
        this.setState({ showPasswordDialog: false });
    };
    handleClickShowErrorCard() {
        this.setState({ showErrorDialog: true });
    };
    
    
    handleClickShowErrorClose() {
        //let { clearCardErrorMsg } = this.props;
        this.setState({ showErrorDialog: false });
        //clearCardErrorMsg();
    };
    
    
    handleClickShowSavedCard() {
        this.setState({ showSuccessDialog: true });
    };
    
    
    handleClickShowSuccessClose() {
        //let { clearCardErrorMsg } = this.props;
        this.setState({ showSuccessDialog: false });
        //clearCardErrorMsg();
    };
    
    handleNewPasswordEmailChange(event){
        this.setState({ newpasswordemail: event.target.value });
    }
    
    onSendPasswordCancel() {
        this.handleForgotPasswordClose();
    }
    
    onSendPasswordPressed(event) {
        //let { loginToPlatewiz} = this.props;
        event.preventDefault();
        //console.log('Form submitted with reCAPTCHA:', this.state.captchaValue);
        if (this.state.captchaValueNewPass) {
            this.sendNewPasswordServer(DEFAULT_VESPAAN_SERVER.url,  this.state.newpasswordemail, this.state.captchaValueNewPass );
            // To reset reCAPTCHA manually
            this.recaptchaRefNewPass.current.reset();
        } else {
            // Handle case where reCAPTCHA is not solved
            console.log('Please complete the reCAPTCHA');
            alert('Please complete the reCAPTCHA first');
        }
    }
    
    
    
    /*onSendPasswordPressed() {
        this.sendNewPasswordServer(DEFAULT_VESPAAN_SERVER.url,  this.state.newpasswordemail);
    }*/
    sendNewPasswordServer( argURL, argEmail,argReCaptchaToken ){
        // const { navigate } = this.props.navigation;
        var self=this;
        
        
        if((argURL != null) || (argURL.length != 0)){
            axios.all(self.getArrayOfNewPassword(argURL, argEmail,argReCaptchaToken )).then(function(responses){
                console.log(responses[0].data);
                self.showResponseOkClose();
                
            }, function(err) {
                console.log(err);
                console.log("Some error occurred on new password request  to server " + err.message +  " the URL is " + argURL );
                self.errorMessage = err.response.data.message;
                self.showNewPasswordError();
                //reject(err);
            });
        }
    }
    
    getArrayOfNewPassword(argURL, argEmail, argReCaptchaToken){
        
        //let baseUrl = argURL+"newpassword?email="+argEmail;
        let baseUrl = argURL+"webnewpassword?email="+argEmail+"&recaptchatoken="+argReCaptchaToken;
        console.log(" on newpassword request url  is " + baseUrl );
        
        var arrayOfGets = [];
        if(argURL != null) {
            
            arrayOfGets.push(axios.post(baseUrl, ));
        }
        return arrayOfGets;
    }
    
    onClientTypeChangeValue(event) {
        let { clientTypeChange } = this.props;
        console.log(event.target.value);
        this.setState({clientType:event.target.value});
        clientTypeChange(event.target.value);
    }
    
    /*handlePasswordChange(event) {
        //event.preventDefault();
        this.setState( { password: event.target.value });
    }*/
    
    
    handleClickShowPassword(){
        
        this.setState( { showPassword: !this.state.showPassword });
    }
    
    render() {
        
        const { classes } = this.props;
        return (
          <React.Fragment >
              
              <Grid container spacing={24}  >
                  <Grid item xs={3} sm={3}>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}  xl={12}   style = { { height:'120%' , backgroundImage: 'url(/static/images/IMG_3000b.png)',
                      backgroundRepeat: "no-repeat",
                      //backgroundSize: "100%",
                      //height:700,
                      //width:300,
                      backgroundPosition: "center center",
                      backgroundSize: "cover",
                      //backgroundAttachment: "fixed"
                  }}>
                      
                      {/*<Grid item xs={12} sm={12} md={6} lg={6}  xl={6}   className={classes.backgroundImage}>  This was for teh background image*/}
                      <div    >
                          <div id="contactus"     >
                              <Grid container spacing={24}>
                                  
                                  {/*}
                                  <Grid container >
                                      <Grid item xs={24} sm={24}    >
                                          <Grid item xs={3} sm={3}    >
                                          </Grid>
                                          <Grid item xs={6} sm={6}    >
                                              <Image src="/static/images/license2c.png" alt="React Image"  style = { {   resizeMode: 'stretch' ,  width:400}}  />
                                          </Grid>
                                          <Grid item xs={3} sm={3}    >
                                          </Grid>
                                      </Grid>
                                  </Grid>*/}
                                  
                                  <Grid container   >
                                      
                                      <Grid item xs={0} sm={0}  md={1} lg={1}>
                                      </Grid>
                                      <Grid item xs={12} sm={12}  md={10} lg={10}>
                                          <Typography   style = { { marginTop:120, fontSize:60, fontWeight:300, textAlign: 'center', alignSelf: 'center', color:'white',  backgroundColor: 'rgba(0, 0, 0, 0.5)', }} >
                                              Welcome to {MainConstants.APPLICATION_NAME}&trade;
                                          </Typography>
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={1} lg={1}>
                                      </Grid>
                                       <Grid item xs={0} sm={0}  md={3} lg={3}>
                                      </Grid>
                                      <Grid item xs={12} sm={12}  md={6} lg={6}  style = {{  alignContent:'center' }} >
                                          <TextField id="email" name="email" label="Email"    style = {{ marginTop:150,  marginLeft:20, marginRight:10, width:'60%',backgroundColor: "#e1f2f1" }} fullWidth   value={this.state.email} onChange={this.handleEmailChange} />
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      
                                      <Grid item xs={0} sm={0}  md={3} lg={3}>
                                      </Grid>
                                      <Grid item xs={12} sm={12} md={6}  lg={6}   >
                                          {/*<TextField id="password" name="password" label="Password" style = {{ marginTop:10, marginLeft:10, marginRight:1, width:'71%', backgroundColor: "#e1f2f1",}} fullWidth  value={this.state.password} onChange={this.handlePasswordChange} />*/}
                                          <TextField
                                            style = {{ marginTop:10, marginLeft:20, marginRight:1, width:'60%', backgroundColor: "#d1e1e9",}} fullWidth
                                            label='Password'
                                            //variant="outlined"
                                            type={this.state.showPassword ? "text" : "password"} // <-- This is where the magic happens
                                            onChange={this.handlePasswordChange}
                                            InputProps={{ // <-- This is where the toggle button is added.
                                                endAdornment: (
                                                  <InputAdornment position="end">
                                                      <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={this.handleClickShowPassword}
                                                      
                                                      >
                                                          {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                                                      </IconButton>
                                                  </InputAdornment>
                                                )
                                            }}
                                          />
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item xs={12} sm={12} md={6}  lg={6}   >
                                          <FormControl component="fieldset"   style = {{ marginTop:10, marginLeft:20,  alignContent:'center' ,width:'60%', backgroundColor:'#e1f2f1' }} >
                                              {/*}<FormLabel component="legend" style={{   color:'Red'}}>Location: </FormLabel> */}
                                              <RadioGroup aria-label="gender" name="clientType" value={this.state.clientType} onChange={this.onClientTypeChangeValue} style={{  marginLeft:10,  flexDirection:'row'}}>
                                                  <FormControlLabel value="vehicleOwner" control={<Radio  color="primary"/>} label="Vehicle Owner"    />
                                                  <FormControlLabel value="towCompany" style={{  marginLeft:10 }} control={<Radio  color="primary"/>} label="Tow Company" />
                                              </RadioGroup>
                                          </FormControl>
                                      </Grid>
                                      
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item  xs={12} sm={12}  md={6} lg={6}   style = {{  marginBottom:30, marginTop:30,  }}   >
                                          
                                          <form onSubmit={this.onLoginToPlatewizPressed}>
                                              
                                              <ReCAPTCHA
                                                //sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // Replace with your actual site key
                                                sitekey={MainConstants.RECAPTCHASITEKEY }
                                                size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                                                ref={this.recaptchaRef}
                                                onChange={this.handleCaptchaChange}
                                                badge="bottomright" // Adjust badge position as needed
                                                style = {{ marginLeft:20,    marginBottom:1, marginTop:2, justifyContent:'center',  alignItems: 'center', }}
                                              />
                                              <Button type="submit" variant="contained" color="primary"
                                                      className={classes.button } >Login</Button>
                                          </form>
                                          
                                          {/*<Button variant="contained" color="primary" onClick={this.onLoginToPlatewizPressed}   className={classes.button }   >
                                              Login
                                          </Button>*/}
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item xs={12} sm={12}  md={6} lg={6}  style = {{  marginBottom:1 }}  >
                                          <a href="/signup"  rel="noreferrer">
                                              <Button variant="contained" color="primary"   className={classes.buttonnu}   >
                                                  New user ?
                                              </Button>
                                          </a>
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      <Grid item  xs={12} sm={12}  md={6} lg={6} style = {{  marginBottom:50 }} >
                                          <Button variant="contained" color="primary" onClick={this.onForgotPasswordPressed}   className={classes.buttonfp}   >
                                              Forgot Password?
                                          </Button>
                                      </Grid>
                                      <Grid item xs={0} sm={0}  md={3} lg={3}  style = {{  alignContent:'center' }} >
                                      </Grid>
                                      
                                  </Grid>
                              </Grid>
                          </div>
                      </div>
                  
                  </Grid>
                  <Grid item xs={3} sm={3}>
                  </Grid>
                  <Dialog
                    open={this.state.showSuccessDialog}
                    onClose={this.handleClickShowSuccessClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControlLogin,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth='3000'
                  >
                      <DialogTitle id="scroll-dialog-title">Login Successful</DialogTitle>
                      <DialogContent id="farshids" dividers="paper"  style = { {backgroundColor:'#e9f4f5' ,textAlign: 'center',  flexDirection:'row' }}>
                            
                              <span style={{ flexDirection:"row" }} >
                              <Typography   style = { { display: 'inline-block',  marginTop:20, fontSize:18, fontWeight:400, textAlign: 'left',   color:'black', flex:1 }} >
                                You successfully logged in. Please select the
                              </Typography>
                                  
                                  {(this.props.clientType === 'vehicleOwner') && <Typography   style = { {display: 'inline-block',  marginTop:10, fontSize:24, fontWeight:400, textAlign: 'left',   color:'black'  ,flex:2 }} >
                                      &nbsp; Vehicle Owner &nbsp;
                                  </Typography>}
                                  {(this.props.clientType === 'towCompany') && <Typography style = { {display: 'inline-block',  marginTop:10, fontSize:24, fontWeight:400, textAlign: 'left',   color:'black'  ,flex:2 }} >
                                      &nbsp; Tow Company &nbsp;
                                  </Typography>}
                                  
                                  
                                  <Typography style = { { display: 'inline-block', marginTop:10, fontSize:18, fontWeight:400, textAlign: 'left',   color:'black', flex:1 }} >
                                  tab above to proceed!
                              </Typography>
                              </span>
                      
                      
                      
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.handleClickShowSuccessClose} color="secondary">Close</Button>
                      </DialogActions>
                  </Dialog>
                  <Dialog
                    open={this.state.showErrorDialog}
                    onClose={this.handleClickShowErrorClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Login Failed!</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          <div>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  Login failed!  Please make sure the correct email and password is entered!
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  {this.errorMessage}
                              </Typography>
                          </div>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.handleClickShowErrorClose} color="secondary">Close</Button>
                      </DialogActions>
                  </Dialog>
                  
                  <Dialog
                    open={this.state.showPasswordDialog}
                    onClose={this.handleForgotPasswordClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">New Password</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          <div>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  We will send you a new password.
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                                  Please enter your email below.
                              </Typography>
                              <Grid item xs={12} sm={12} md={12} lg={12}   >
                                  <TextField id="pwemail" name="pwpassword" label="Email" style = {{ marginTop:10, marginLeft:1, marginRight:10, width:'90%', backgroundColor: "#e1f2f1",}} fullWidth  value={this.state.newpasswordemail} onChange={this.handleNewPasswordEmailChange} />
                              </Grid>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  Note: The email must be the one you registered with {MainConstants.APPLICATION_NAME}.
                              </Typography>
                          
                          </div>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.onSendPasswordCancel} color="secondary"  className={classes.buttonsignup2}>Cancel</Button>
                          <form onSubmit={this.onSendPasswordPressed}>
                              
                              <ReCAPTCHA
                                //sitekey="6LdjmQ0rAAAAADU4GZUVtQmSXHSH-EBY11cjrAGx" // Replace with your actual site key
                                sitekey={MainConstants.RECAPTCHASITEKEY }
                                size="normal" // Use "invisible" for reCAPTCHA v3 or "normal" for v2
                                ref={this.recaptchaRefNewPass}
                                onChange={this.handleCaptchaChangeNewPass}
                                badge="bottomright" // Adjust badge position as needed
                              />
                              <Button  type="submit" color="secondary"   className={classes.buttonsignup} >Submit</Button>
                          </form>
                          {/*
                          <Button onClick={this.onSendPasswordPressed} color="secondary">Submit</Button>
                          */}
                      </DialogActions>
                  
                  </Dialog>
                  <Dialog
                    open={this.state.showResponseOkDialog}
                    onClose={this.handleResponseOkClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">New Password</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          <div>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  New password is sent to your email.
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                                  Use the new password to login to your account.
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  You will be returned to Login screen.
                              </Typography>
                          
                          </div>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.handleResponseOkClose} color="secondary">Ok</Button>
                      </DialogActions>
                  </Dialog>
                  <Dialog
                    open={this.state.showNewPasswordErrorDialog}
                    onClose={this.handleNewPasswordErrorClose}
                    scroll={'paper'}
                    classes={{
                        paper: classes.formControl2,
                    }}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    maxWidth="xl"
                  >
                      <DialogTitle id="scroll-dialog-title">Wrong Email</DialogTitle>
                      <DialogContent id="farshids" dividers="paper">
                          <div>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  Wrong email was entered!
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left', color:'black', }} >
                                  Please make sure you entered the right email
                              </Typography>
                              <Typography   style = { { marginTop:20, fontSize:16, fontWeight:400, textAlign: 'left', alignSelf: 'left',  color:'black', }} >
                                  and submit again.
                              </Typography>
                          </div>
                      </DialogContent>
                      <DialogActions>
                          <Button onClick={this.handleNewPasswordErrorClose} color="secondary">Ok</Button>
                      </DialogActions>
                  </Dialog>
              </Grid>
          </React.Fragment>
        
        
        );
    }
}


Login.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        //accountsArray: state.account.accountsArray,
        //CompanyDeleteResponse:state.account.deleteCompanyResp,
        //CompanySaveResponse:state.account.saveCompanyResp,
        //locationsArray:state.location.locationsArray,
        //vcArray:state.videocontroller.vcArray,
        //camerasArray:state.camera.camerasArray,
        //errorCMsg:state.account.errorCMsg,
        clientType:state.login.clientType,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loginAction:loginAction,
        updateLoginDataAction:updateLoginDataAction,
        isAuthenticatedAction:isAuthenticatedAction,
        clientTypeChange:clientTypeChange,
        loadSingleUserAndCompanyData:loadSingleUserAndCompanyData,
        
        
    }, dispatch);
};

//export default withStyles(styles)(AppView);
//export default connect(mapStateToProps, mapDispatchToProps)(AppView);



/*Login.propTypes = {
		classes: PropTypes.object.isRequired,
};*/
//export default withStyles(styles)(Login);
//export default connect(mapStateToProps, mapDispatchToProps)(Login);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Login));
